import { apiMethods } from './api_methods';

function getTopLevelDomain(domain) {
    // this should return only the
    // extension and the top level of the domain
    // ex: futurewalottery.com
    // from stg01.mylottery360.futurewalottery.com
    return domain.split('.').slice(-2).join('.');
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

function setCookieValueByName(cookieName, cookieValue) {
    if (typeof document === 'undefined') {
        return;
    }

    document.cookie = `${cookieName}=${cookieValue}; Path=/; Domain=${getTopLevelDomain(document.location.hostname)}`;
    return cookieValue;
}

// Here is the format of the request object im expecting
// {
//      method : "foo",
//      args : {
//          bar : "baz"
//      }
// }
class ApiClientRequests {
    constructor(promotion_config = {}) {
        this.auth_token = '';
        this.methods = apiMethods(promotion_config);
    }

    async apiMethod(requestData) {
        var retVal = null;

        const method = this.getMethod(requestData);

        if (method.action == 'get') {
            var getRoute = '/api/' + method.method(this.buildUrl(requestData));

            let getRequestData = this.urlEncode(requestData);

            if (getRequestData) {
                getRoute += getRequestData;
            }

            retVal = await this.getData(getRoute, requestData);
        } else if (method.action == 'post') {
            retVal = await this.postData('/api/' + method.method(this.buildUrl(requestData)), this.buildPayload(requestData), requestData);
        } else if (method.action == 'put') {
            retVal = await this.postData('/api/' + method.method(this.buildUrl(requestData)), this.buildPayload(requestData), requestData, true);
        } else if (method.action == 'external') {
            var getRoute = method.method(this.buildUrl(requestData));

            let getRequestData = this.urlEncode(requestData);

            if (getRequestData) {
                getRoute += getRequestData;
            }

            retVal = await this.getData(getRoute, requestData);
        }
        return retVal;
    }

    getMethod(postingData) {
        return this.methods.filter((val) => {
            return postingData.method == val.name;
        })[0];
    }

    additionalHeaders(request, requestData) {
        const method = this.getMethod(requestData);
        method.headers.forEach((header) => {
            request.setRequestHeader(header.name, header.processHeader(requestData.headers[header.name]));
        });
    }

    async getData(url = '', requestData) {
        if (typeof window !== 'undefined') {
            // Create the XHR request
            var request = new XMLHttpRequest();
            const adtlHeaders = this.additionalHeaders.bind(this);
            // Return it as a Promise
            return await new Promise(function (resolve, reject) {
                // Setup our listener to process compeleted requests
                request.onreadystatechange = function () {
                    // Only run if the request is complete
                    if (request.readyState !== 4) return;

                    const newSpat = request.getResponseHeader('X-Auth-Spat');
                    if (newSpat) {
                        let authToken = getCookie('AuthToken');
                        let newAuthToken = JSON.parse(authToken);
                        // Strip additional slashes from the SPAT before re-stringify
                        newAuthToken.spat = newSpat.replace('\\', '');
                        setCookieValueByName('AuthToken', JSON.stringify(newAuthToken));
                    }

                    // Process the response
                    resolve(request.response ? JSON.parse(request.response) : {});
                };

                // Setup our HTTP request
                request.open('GET', url, true);
                request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                request.setRequestHeader('Content-Type', 'application/json;charset=utf-8');
                adtlHeaders(request, requestData);
                request.withCredentials = true;

                request.send();
            });
        }
    }

    async postData(url = '', data = {}, requestData, isPut = false) {
        if (typeof window !== 'undefined') {
            // Create the XHR request
            var request = new XMLHttpRequest();

            const adtlHeaders = this.additionalHeaders.bind(this);
            // Return it as a Promise
            return await new Promise(function (resolve, reject) {
                // Setup our listener to process compeleted requests
                request.onreadystatechange = function () {
                    // Only run if the request is complete
                    if (request.readyState !== 4) return;

                    const newSpat = request.getResponseHeader('X-Auth-Spat');
                    if (newSpat) {
                        let authToken = getCookie('AuthToken');
                        let newAuthToken = JSON.parse(authToken);
                        // Strip additional slashes from the SPAT before re-stringify
                        newAuthToken.spat = newSpat.replace('\\', '');
                        setCookieValueByName('AuthToken', JSON.stringify(newAuthToken));
                    }
                    // Process the response
                    resolve(request.response ? JSON.parse(request.response) : {});
                };

                // Setup our HTTP request
                request.open(isPut ? 'PUT' : 'POST', url, true);
                // request.setRequestHeader('Accept', 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8')
                request.setRequestHeader('Content-Type', 'application/json;charset=utf-8');
                request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                adtlHeaders(request, requestData);
                request.withCredentials = true;
                // Send the request
                request.send(JSON.stringify(data));
            });
        }
    }

    buildPayload(postingData) {
        const method = this.getMethod(postingData);
        var requestObj = {};

        if (Array.isArray(postingData.args)) {
            requestObj = postingData.args;
        } else {
            method.args.forEach((arg) => {
                requestObj[arg.name] = arg.processArgs(postingData.args[arg.name]);
            });
        }

        method.postBuild(postingData, requestObj);

        return requestObj;
    }

    buildUrl(postingData) {
        const method = this.getMethod(postingData);

        var requestObj = {};

        method.urlArgs.forEach((urlArg) => {
            requestObj[urlArg.name] = urlArg.processArgs(postingData.urlArgs[urlArg.name]);
        });

        return requestObj;
    }

    urlEncode(postingData) {
        const method = this.getMethod(postingData);
        var requestObj = {};

        method.args.forEach((arg) => {
            let processedArg = arg.processArgs(postingData.args[arg.name]);

            if (processedArg) {
                requestObj[arg.name] = processedArg;
            }
        });

        var str = [];
        for (var p in requestObj) {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(requestObj[p]));
        }
        return str.length ? '?' + str.join('&') : '';
    }
}

const apiClient = (config) => {
    return new ApiClientRequests(config);
};
export default apiClient;
